import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  Close, Send,
} from '@mui/icons-material';
import { i18n } from '../../translate/i18n';
import {
	Avatar,
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  FormControl,
  TextField,
} from "@mui/material";

import { makeStyles, withStyles } from '@mui/styles';

import { ProfileForm, ProfileFormName, ProfileFormPicture} from './styles';

const styles = {
	modalStyle: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
	},
	avatar: {
		width: 60,
		height: 60,
		fontSize: 13
	},
	sendButton: {
		backgroundColor: 'green',
		color: '#fff',
		margin: '0.75rem 1rem'
	},
	closeButton: {
		position: 'absolute',
		fontSize: '1.1rem',
		top: 10,
		right: 10,
	},
	uploadFileBox: {
		width: '80%',
	},
};

const useStyles = makeStyles(() => ({
	paper: { minWidth: "50vw" },
	root: {
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey"
    },
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "grey",
			borderWidth: '1px'
    },
  }
}));


const DialogTitleCustom = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
      <DialogTitle className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton
              aria-label="close"
              className={classes.closeButton}
              onClick={onClose}
              size="large">
            <Close />
          </IconButton>
        ) : null}
      </DialogTitle>
  );
});

const EquipmentChangeStatusInput = ({ auth, handleSave, title = 'Criar uma publicação', setContent, closeModal, type }) => {
    const classes = useStyles();
    const [inputType, setInputType] = useState('text');
    const [message, setMessage] = useState('');
    const [messageError, setMessageError] = useState(false);

    const [userName, setUserName] = useState(null);

    const fetchLoggedUser = async () => {
			setUserName(auth.name);
    };

    useEffect(() => {
			fetchLoggedUser();
    }, []);

    const handleSend = () => {
			let error = false;

			if(!message) {
				error = true;
				setMessageError(true);
			}

			if(!error) {
				setContent(message);
				handleSave();
			}
    };

		const handleType = (colorType) => {
			switch (colorType) {
				case 'inactivate': return '#585858';
				case 'maintenance': return '#0363c3';
				case 'return-maintenance': return 'darkblue';
				case 'reactivate': return 'green';
				default: break;
			}
		}

    return (
        <Dialog
            classes={{ paper: classes.paper }}
            style={styles.modalStyle}
            maxWidth="lg"
            fullWidth
            scroll='body'
            open
            onClose={closeModal}
        >

            <DialogTitleCustom id="customized-dialog-title" onClose={closeModal}>
                <div style={{ color: handleType(type), fontWeight: 'bold' }}>{title}</div>
            </DialogTitleCustom>

            <DialogContent dividers>

                <ProfileForm>
                    <ProfileFormPicture>
                        <Avatar style={styles.avatar}>{' '}</Avatar>
                    </ProfileFormPicture>
                    <ProfileFormName>{userName}</ProfileFormName>
                </ProfileForm>

                {inputType === 'text' &&
                    <FormControl variant="standard" fullWidth>
                        <TextField
                            className={classes.root}
                            value={message}
                            margin='normal'
                            error={messageError}
                            placeholder={i18n.t('textFieldEquipStatusInput.placeholder')}
                            onChange={(e) => { setMessage(e.target.value); setContent(e.target.value); setMessageError(false); }}
                            autoFocus
                            multiline
                            rows={4}
                            variant='outlined'
                            helperText={i18n.t('textFieldEquipStatusInput.helperText')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                }
            </DialogContent>

            <DialogActions>
                <Button startIcon={<Send />} variant="contained" onClick={handleSend} style={styles.sendButton}>
                        {i18n.t('buttonEquipStatusInput.text')}
                </Button>
            </DialogActions>

        </Dialog>
    );
};

export default connect((state) => ({ auth: state.auth }))(EquipmentChangeStatusInput);
